<template>
    <v-row class="pb-offset ma-0">
        <standard-smtp class="pb-4"></standard-smtp>
        <pec-smtp class="pb-4"></pec-smtp>
        <pec-massive-smtp v-if="isPecMassiveEnabled"></pec-massive-smtp>
    </v-row>
</template>

<script>

    import PecSmtp from '@/components/modules/settings/PecSMTP'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
    import StandardSmtp from '@/components/modules/settings/StandardSMTP'
    import PecMassiveSmtp from '@/components/modules/settings/PecMassiveSMTP'

    export default {
        name: 'settings-smtp',
        mixins: [SettingsOptionsMixin],
        components: {
            PecSmtp,
            StandardSmtp,
            PecMassiveSmtp,
        },
        props: {},
        data() {
            return {
            }
        },
        computed: {
            isPecMassiveEnabled() {
                return !!this.$store.getters.isPecMassiveEnabled
            },
        },
    }
</script>

<style scoped>

</style>